// extracted by mini-css-extract-plugin
export default {"wrap":"s_wrap__gtlB-","title":"s_title__zdmSy","rangeWrap":"s_rangeWrap__AMIfP","button":"s_button__sMa5t","active":"s_active__RLIEF"};